export default __webpack_public_path__ + "static/media/white_mode_table.0252cb1a.svg";